import { createFileRoute } from '@tanstack/react-router';
import WorkflowsPage from '@features/admin/workflows/WorkflowsPage.tsx';
import { useAdminWorkflowStore } from '@features/admin/workflows/useAdminWorkflowStore.ts';

export const Route = createFileRoute('/admin/workflows/')({
  component: RouteComponent,
  beforeLoad: () => {
    useAdminWorkflowStore.getState().loadWorkflows();
  },
});

function RouteComponent() {
  return <WorkflowsPage />;
}
